const MicronesiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111897)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#338AF3"
      />
      <path
        d="M19.9995 8.69531L20.8628 11.3525H23.6569L21.3966 12.9948L22.2599 15.6519L19.9995 14.0097L17.7392 15.6519L18.6027 12.9948L16.3423 11.3525H19.1363L19.9995 8.69531Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.6958 20.0003L11.353 19.1368V16.3428L12.9953 18.6032L15.6524 17.7399L14.0102 20.0003L15.6524 22.2604L12.9953 21.397L11.353 23.6574V20.8635L8.6958 20.0003Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9997 31.3052L19.1363 28.648H16.3423L18.6028 27.0057L17.7394 24.3486L19.9997 25.9908L22.2599 24.3486L21.3965 27.0057L23.6569 28.648H20.863L19.9997 31.3052Z"
        fill="#F0F0F0"
      />
      <path
        d="M31.3042 20L28.647 20.8634V23.6574L27.0048 21.397L24.3477 22.2604L25.9898 20L24.3477 17.7398L27.0048 18.6032L28.647 16.3428V19.1368L31.3042 20Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111897">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MicronesiaSvg;
